// extracted by mini-css-extract-plugin
export default {"form":"loginForm_form__v963I","title":"loginForm_title__97YkZ","btn":"loginForm_btn__k14lG"};